const DOCUMENT_ITEM_DISPLAY_FIELDS = new Set([
  'productImage',
  'varietyImage',
  'priceImage',
  'productName',
  'varietyName',
  'categoryName',
  'description',
  'priceDescription',
]);

export const compactDocumentItemPayload = (item) => {
  if (!item || typeof item !== 'object') return item;

  return Object.fromEntries(
    Object.entries(item).filter(([key]) => !DOCUMENT_ITEM_DISPLAY_FIELDS.has(key))
  );
};

export const compactDocumentItemsPayload = (items) =>
  Array.isArray(items) ? items.map(compactDocumentItemPayload) : [];

export const compactPayloadLineItems = (payload, itemKey) => {
  if (!payload || typeof payload !== 'object' || !Array.isArray(payload[itemKey])) {
    return payload;
  }

  return {
    ...payload,
    [itemKey]: compactDocumentItemsPayload(payload[itemKey]),
  };
};

export const compactPurchasePayload = (payload) =>
  compactPayloadLineItems(payload, 'purchaseItems');

export const compactQuotationPayload = (payload) =>
  compactPayloadLineItems(payload, 'items');

export const compactPurchaseItemsPayload = compactDocumentItemsPayload;

export const compactQuotationItemsPayload = compactDocumentItemsPayload;
